module.exports = __webpack_public_path__ + "static/img/b5_body.c211d58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/core/b5_body.png
// module id = fYas
// module chunks = 1